import './ClOfferListPage.css';

import React from 'react';
import classname from '@search/classname/src';

const cn = classname.bind(null, 'ClOfferListPage');

export function ClOfferListPage({ children }: {
    children: React.ReactNode;
}) {
    return (
        <div className={cn()}>
            <div className={cn('inner')}>{children}</div>
        </div>
    );
}
